// manages fetching of one or more collections
// required parameters:
//	cm_dataTypes		- list of API calls
// optional parameters:
//	cm_orderByDirection	- order by direction for API sorting
//	cm_orderByProperty	- order by field for API sorting
//	cm_pageMax			- number of records per page for API
//						  if not defined, paging is disabled
//	cm_sortComparator	- API data set sort comparator (overrides default comparator)
//	cm_sortDirection	- API data set sort direction using default comparator (ignored if cm_sortProperty is not defined)
//	cm_sortProperty		- API data set sort property using default comparator

define(function(require) {
	const $ = require('jquery');
	const CN = require('civicsUtils/constants');
	// do not reference generic collection here in the manager to break the circular reference
	//const GenericCollection = require('civicsBase/generic_collection');
	const GenericHelper = require('civicsBase/generic_helper');
	const UrlParametersGenerator = require('civicsUtils/UrlParameters');
	const DEFAULT_SORT_DIRECTION = CN.SORT_ASC;

	var CollectionManager = function(dataTypeContext,options) {
		//setup default
		if ( !options ){
			options = {};
		}

		this.hasMorePage = true;

		// log input parameters
		// if (__DEV__) console.log('cm: dataTypes', dataTypeContext,
		// 	'cm_orderByDirection', options.cm_orderByDirection, 'cm_orderByProperty', options.cm_orderByProperty,
		// 	'cm_pageMax', options.cm_pageMax, 'cm_sortComparator', options.cm_sortComparator,
		// 	'cm_sortDirection', options.cm_sortDirection, 'cm_sortProperty', options.cm_sortProperty,
		// 	'cm_collectionManager', options.cm_collectionManager);

		// setup properties
		this.dataTypes = $.extend(true, [], dataTypeContext);
		this.failOnError = options.cm_failOnError === true;

		// define urlParameters
		this.urlParametersGenerator = new UrlParametersGenerator();
		if (typeof options.cm_orderByProperty === 'string') {
			var direction = (typeof options.cm_orderByDirection === 'string') ?
				options.cm_orderByDirection : DEFAULT_SORT_DIRECTION;
			this.urlParametersGenerator.setOrderBy(options.cm_orderByProperty, direction);
		}
		this.isPagingOn = false;
		if (typeof options.cm_pageMax === 'number') {
			this.pageMax = options.cm_pageMax;
			this.urlParametersGenerator.setPage(1, this.pageMax);
			this.isPagingOn = true;
		}
		this.collectionManager = options.cm_collectionManager;

		// define sort comparator
		if (options.cm_sortComparator instanceof Function) {
			this.sortComparator = {
				comparator: options.cm_sortComparator,
				isDefault: false
			};
		} else {  //if (typeof options.cm_sortProperty === 'string') {
			// if no comparator is entered use default
			this.sortComparator = function() {
				var _direction = -1; // descending
				var _property = '';
				return {
					comparator: function(a, b) {
						// add sorting parameters
						var valA = a.get(_property);
						var valB = b.get(_property);

						if(typeof valA == 'number' && typeof valB == 'number'){
							var retval = (valA > valB) ? 1 : (valA < valB) ? -1 : 0;
						} else {
							if ( valA ) valA = valA.toLowerCase();
							if ( valB ) valB = valB.toLowerCase();
							var retval = (valA > valB) ? 1 : (valA < valB) ? -1 : 0;
						}

						return retval * _direction;
					},
					setProperty: function(property) {
						if (typeof property === 'string') {
							_property = property;
						}
					},
					setDirection: function(direction) {
						if (typeof direction === 'string') {
							_direction = direction == CN.SORT_ASC ? 1 : -1;
						}
					},
					isDefault: true
				}
			}();
			this.sortComparator.setProperty(options.cm_sortProperty);
			var direction = (typeof options.cm_sortDirection === 'string') ?
				options.cm_sortDirection : DEFAULT_SORT_DIRECTION;
			this.sortComparator.setDirection(direction);
		}
		var self = this;
		// fetchMore tracks infinite scolling trigger
		this.fetchMore = function() {
			var _hasNextPage = true;
			var _lastCollectionCount = 0;
			var _numTimesUnchanged = 0;

			function start() {
				_hasNextPage = true;

				_continueFetching = true; /*** to be removed ***/
				_triggerPosition = 0; /*** to be removed ***/
			};

			function stop() {
				_hasNextPage = false;

				_continueFetching = false; /*** to be removed ***/
			};

			function hasNextPage() {
				return _hasNextPage;
			};

			/*** to be removed ***/
			var _continueFetching = true;
			var _triggerPosition = 0;
			function setTriggerPosition(position) {
				// trigger scrolling position to fetch more data
				_triggerPosition = position;
			};
			function continueFetching(position) {
				// position - current scrolling position
				if (typeof position === 'number') {
					return (_continueFetching && (position > _triggerPosition));
				}

				this.updateLastFetchCount();
				if(_numTimesUnchanged <1 ){
					return true;
				} else {
					this.stop();
					return false;
				}
			};/*** to be removed ***/
			function updateLastFetchCount(){
				var currentCollectionCount = this.self.collection.length;
				if(currentCollectionCount!=_lastCollectionCount){
					_lastCollectionCount = currentCollectionCount;
					_numTimesUnchanged = 0;
				} else {
					_numTimesUnchanged++;
				}
			}

			return {
				// public interface
				start: start,
				stop: stop,
				continueFetching: continueFetching,/*** to be removed ***/
				setTriggerPosition: setTriggerPosition,/*** to be removed ***/
				hasNextPage: hasNextPage,
				updateLastFetchCount:updateLastFetchCount,
				self:self
			};
		}();
		this.fetchInProgress = false;
	};

	// define prototype functions
	$.extend(CollectionManager.prototype, {
		//sort locally after the collection is populated
		sort: function(attributeName,direction,options) {
			return this.collection.sort(attributeName,direction,options);
		},
		// setters
		setDataTypes: function(types) {
			this.dataTypes = $.extend(true, [], types);
		},
		setFilter: function(filter) {
			if (filter instanceof Object) {
				this.urlParametersGenerator.setExtendedFilter(filter);
			}
		},
		setOrderBy: function(property, direction) {
			if (typeof property === 'string') {
				this.urlParametersGenerator.setOrderBy(property, direction);
			}
		},
		clearOrderBy: function() {
			this.urlParametersGenerator.clearOrderBy();
		},
		setSelect: function(properties){
			this.urlParametersGenerator.setSelect(properties);
		},
		setSort: function(property, direction) {
			// set only if default comparator is used
			if (this.sortComparator instanceof Object && this.sortComparator.isDefault) {
				if (typeof property === 'string') {
					this.sortComparator.setProperty(property);
					if (typeof direction === 'string') {
						this.sortComparator.setDirection(direction);
					}
				}
			}
		},
		setSortComparator: function(comparator) {
			// replace comparator
			if (comparator instanceof Function) {
				this.sortComparator = {
					comparator: comparator,
					isDefault: false
				};
			}
		},
		setTriggerPosition: function(position) {
			this.fetchMore.setTriggerPosition(position);
		},
		setPassThrough: function(passThrough, value, excludedDataType) {
			this.urlParametersGenerator.setPassThrough(passThrough, value, excludedDataType);
		},
		clearPassThrough: function(id) {
			this.urlParametersGenerator.clearPassThrough(id);
		},
		// fetch functions
		fetchAllCollections: function(createNewCollection, parentModel) {
			// fetch data from all data types
			var defer = $.Deferred();

			// check if fetching in progress
			if (this.fetchInProgress) {
				defer.reject();
				return defer.promise();
			}
			this.fetchInProgress = true;

			// check to see if new collection needs to be created
			if (createNewCollection) {
				this.collection = new GenericHelper();
				this.hasMorePage = true;
				// initialize parameters
				if (this.isPagingOn) {
					this.urlParametersGenerator.setPage(1, this.pageMax);
				}
				for (var i = 0; i < this.dataTypes.length; i++) {
					// ADD allDataFetched element to dataTypes
					this.dataTypes[i].allDataFetched = false;
				};
				// reset infinite scolling
				this.fetchMore.start();
			}

			// Call all of the REST api urls
			var options = {};
			this.deferredCollection = [];
			for (i = 0; i < this.dataTypes.length; i++) {
				if ( !this.dataTypes[i].disabled ){ // datatype can be temporarily disabled
					// if visible parameter is undefined, set to true
					var visible = (typeof this.dataTypes[i].visible === 'boolean') ? this.dataTypes[i].visible : true;
					if (visible && !this.dataTypes[i].allDataFetched) {
						options.dataType = this.dataTypes[i];
						var fetchCollectionPromise = this.fetchCollection(options, parentModel);
						if (fetchCollectionPromise !== null) {
							this.deferredCollection.push(fetchCollectionPromise);
						}
					}
				}
			}

			// Handle the results (collections) from each of the REST api calls
			$.when.apply($, this.deferredCollection)
				.done(_.bind(function() {
					// create container for all collections fetched in this batch
					var lastFetchAllCollection = new GenericHelper();

					// define sort compartor
					if (this.sortComparator instanceof Object) {
						lastFetchAllCollection.comparator = this.sortComparator.comparator;
					}
					// consolidate each collection fetched
					$.each(arguments, function(index, deferredCollectionResult) {
						lastFetchAllCollection.add(deferredCollectionResult.models);
					});
					// add consolidated collection to existing collection
					this.collection.add(lastFetchAllCollection.models);
					// check all data fetched

					if (this.isPagingOn && lastFetchAllCollection.length == 0) {
						if(this.hasMorePage){
							this.hasMorePage = false;
						} else {
							this.fetchMore.stop();
						}
					};
					// increment to next page.
					this.urlParametersGenerator.nextPage();

					// return collection and update position flag
					this.fetchInProgress = false;
					defer.resolve({
						collection: this.collection,
						updateTriggerPosition: this.fetchMore.continueFetching(), /** to be removed **/
						updateNextPage: this.fetchMore.hasNextPage()
					});
				}, this))
				.fail(function(data) {
					// one or more fetch failed
					defer.reject(data);
					this.fetchInProgress = false;
				})
				.always(_.bind(function() {
					// fetching completed
					this.fetchInProgress = false;
				}, this));
			return defer.promise();
		},
		fetchCollection: function(options, parentModel) {
			// fetch individual collection
			var dataType = options.dataType;
			var failOnError = this.failOnError;

			options = _.extend({}, options);

			// define urlParamters
			var urlParametersGenerator = $.extend(true, {}, this.urlParametersGenerator);
			if (dataType.select instanceof Object) {
				urlParametersGenerator.setSelect(dataType.select);
			}
			if(dataType.passThroughString){
				urlParametersGenerator.setPassThrough(dataType.passThroughString);
			}
			if (dataType.urlModifier instanceof Function) {
				var urlParameters = dataType.urlModifier(urlParametersGenerator, parentModel);
				if (urlParameters === null) {
					// skip
					return null;
				}
				urlParametersGenerator = urlParameters;
			}

			// create new collection
			var urlParameters = $.extend(true, {}, urlParametersGenerator.getUrlParameters());
			var helperCollection = new GenericHelper();
			if ( dataType.generateId ){
				helperCollection.generateId = dataType.generateId;
			}
			helperCollection.initialize(options,urlParameters);
			if (dataType.model) {
				helperCollection.setModel(dataType.model);
			}
			// fetch data
			// note: could not incorporate the deferred promise returned by fetch
			//   due to different data elements that is returned
			var defer = $.Deferred();
			var collectionData;
			helperCollection.fetch({
					success: function(data) {
						// check all data fetched for this type
						//if (__DEV__) console.log('cm.fetchCollection: data', data);
						if (data.length < data.urlParameters.page.max) {
							if(!this.hasMorePage){
								dataType.allDataFetched = true;
							}
						}
						collectionData = data;
					}.bind(this),
					error: function(data) {
						//defer.reject(data);
						if (data.length < data.urlParameters.page.max) {
							dataType.allDataFetched = true;
						}
						collectionData = data;
					},
				})
				.then(
					()=>{this.afterFetch(dataType,defer,collectionData)},
					(response, status, xhrResponse)=>{
						if ( failOnError )
							defer.reject(response, status, xhrResponse);
						else
							this.afterFetch(dataType,defer,collectionData)
					}
			); //set both success and fail function to the same afterFetch. that will avoid web app being stuck in a bad state.
			return defer.promise();
		},
		afterFetch: function(dataType,defer,collectionData) {
			// parameters passed in to function is subset of data passed from fetch success
			// so collectionData is needed to preserve complete data
			var doPostProcess = typeof dataType.postProcess != 'undefined';
			var doCollectMore = typeof dataType.dataTypes2 != 'undefined';
			if (doPostProcess || doCollectMore) {
				var deferredCollection = [];
				$.each(collectionData.models, function(idx, currentModel) {
					if (doCollectMore) {
						var collectionManager2 = new CollectionManager(dataType.dataTypes2, dataType.options2);
						var deferred = collectionManager2.fetchAllCollections(true, currentModel);
						deferredCollection.push(deferred);
						$.when(deferred)
							.done(_.bind(function(data2) {
								if (doPostProcess) {
									dataType.postProcess(currentModel, data2.collection.models);
								} else {
									currentModel.set("cm_collection2", data2.collection);
								}
							}, this))
							.fail(function(data2) {
								console.log('Error getting secondary data');
							})
					} else {
						dataType.postProcess(currentModel);
					}
				});
				// resolve deferred object
				if (doCollectMore) {
					$.when.apply($, deferredCollection)
						.done(function(data) {
							defer.resolve(collectionData);
						});
				} else {
					defer.resolve(collectionData);
				}
			} else {
				defer.resolve(collectionData);
			}
		},
		/*** to be removed , replaced by hasNextPage ***/
		continueFetching: function(currentPosition) {
			return (!this.fetchInProgress && this.fetchMore.continueFetching(currentPosition));
		},
		hasNextPage: function() {
			return (!this.fetchInProgress && this.fetchMore.hasNextPage());
		}
	});
	return CollectionManager;
});
